"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseTerms = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./PurchaseTerms.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PurchaseTerms = props => {
  const {
    terms
  } = props;
  if (!terms || terms.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['container']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading5, null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u043F\u0440\u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u0445 \u043F\u043E\u043A\u0443\u043F\u043A\u0438"), /*#__PURE__*/React.createElement("div", {
    className: style['labels']
  }, terms.map((term, idx) => /*#__PURE__*/React.createElement(_uiKit.Label, {
    key: idx,
    background: "control-main-primary-disabled",
    color: "text-primary-default"
  }, term))));
};
exports.PurchaseTerms = PurchaseTerms;